import React from 'react';

import { clsx } from 'clsx';

import { useLayoutContext } from '@ott/layout-context';

import FadeIn from 'src/components/elements/FadeIn';

import { CARDS_DATA } from './constants';

import styles from './HowItWorks.scss';

const HowItWorks = () => {
  const { isDesktop } = useLayoutContext();

  return (
    <div className={styles.howItWorks}>
      <div className={styles.title}>
        <FadeIn delay={0.2}>
          How <span className={styles.titleThin}>it works</span>
        </FadeIn>
      </div>
      <div className={styles.cardsWrapper}>
        {CARDS_DATA.slice(0, 2).map((card) => (
          <FadeIn key={card.id} className={clsx(styles.card, styles[`card${card.id}`])} delay={0.4}>
            <h2 className={styles.cardTitle}>{card.title}</h2>
            <div className={styles.cardDescription}>{card.description}</div>
            <video
              autoPlay={true}
              preload="auto"
              loop={true}
              muted={true}
              playsInline={true}
              className={styles.video}
            >
              <source src={card.video} type="video/mp4" />
            </video>
          </FadeIn>
        ))}
        {CARDS_DATA.slice(2, 3).map((card) => (
          <FadeIn key={card.id} delay={0.4} className={clsx(styles.card, styles[`card${card.id}`])}>
            <div className={styles.cardText}>
              <h2 className={styles.cardTitle}>{card.title}</h2>
              <div className={styles.cardDescription}>{card.description}</div>
            </div>
            {card.video && (
              <video
                autoPlay={true}
                preload="auto"
                loop={true}
                muted={true}
                playsInline={true}
                className={styles.video}
              >
                <source src={isDesktop ? card.video : card.video_mobile} type="video/mp4" />
              </video>
            )}
          </FadeIn>
        ))}
      </div>
    </div>
  );
};

export default HowItWorks;
